import { CardStatus, FilterStatusState, FilterValidityState } from './cardFilterTypes';

export const STATUS_SORT_PRIORITY: Record<CardStatus, number> = {
  cardBlocked: 5,
  userDeleted: 4,
  cardExpired: 3,
  accessRightsChanged: 2,
  userExpiresSoon: 1,
  cardExpiresSoon: 0
};

export const filterStatusDefault: FilterStatusState = {
  cardBlocked: false,
  userDeleted: false,
  cardExpired: false,
  accessRightsChanged: false,
  userExpiresSoon: false
};

export const filterValidityDefault: FilterValidityState = null;
export const filterAssignedDefault = null;
